<template>
    <awesome-table
        :labels="labels"
        :items="products"
        :options="{
            sort: false,
            addButton: false,
            pagination: false,
            searchInput: false,
            filters: false,
            link: false,
            isCard: false
        }"
        @row-click="onRowClick"
    >
        <template #[`items.attributes`]="{ item }">
            <div v-if="item.attributes.length">
                <div v-for="(attribute, index) in item.attributes" :key="index">
                    <span>
                        {{ attribute.group.name }}: {{ attribute.value }}
                    </span>
                </div>
            </div>
            <div v-else>
                -
            </div>
        </template>
    </awesome-table>
</template>

<script>
export default {
    props: {
        products: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            includeHeader: false,
            includeDeleteAction: false
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '200px' },
                { value: 'sku', text: 'SKU', width: '200px' },
                {
                    value: 'totalPrice',
                    width: '200px',
                    type: 'number',
                    filter: 'formatPrice'
                },
                {
                    value: 'quantity',
                    type: 'number',
                    width: '150px'
                },
                {
                    value: 'attributes',
                    width: '300px'
                }
            ];
        }
    },

    methods: {
        onRowClick(item) {
            this.$router.push(
                `/shops/${item.shopId}/products/${item.productId}/variants/${item.id}/edit`
            );
        }
    }
};
</script>
